module.exports = __webpack_public_path__ + "static/media/shortcode.73380a7d.svg";